<template>
  <v-dialog
    v-model="isActive"
    :max-width="290"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        :label="label"
        :value="filteredValue"
        readonly
        :disabled="disabled"
        :rules="rules"
        :error-messages="errorMessages"
        :required="required"
        size="3"
        :clearable="defaultColor && filteredValue !== defaultColor"
        @click:clear="() => resetToDefault()"
        v-on="on"
      >
        <v-icon
          v-if="icon"
          slot="prepend"
          :color="filteredValue"
          @click="isActive = true"
        >
          {{ icon }}
        </v-icon>
      </v-text-field>
    </template>
    <v-card :class="{'ft-color-picker': true, 'ft-has-title': !!label}">
      <v-card-title
        v-if="!!label"
        class="px-2 py-2"
      >
        <v-icon
          v-if="icon"
          :color="filteredValue"
          class="pr-2"
          @click="() => resetToPrevious()"
        >
          {{ icon }}
        </v-icon>
        {{ label }}
      </v-card-title>
      <v-card-text
        class="pa-0"
      >
        <v-color-picker
          v-model="lazyValue"
          :disabled="disabled"
          class="mx-auto"
          mode="hexa"
          flat
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="error"
          text
          @click="() => closePicker()"
        >
          Cancel
        </v-btn>
        <v-btn
          color="primary"
          text
          @click="() => set()"
        >
          Done
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'ColorPicker',

  props: {
    disabled: Boolean,
    readonly: Boolean,
    noAlpha: Boolean,
    value: String,
    defaultColor: {
      type: String,
      default: '#000000FF'
    },
    label: String,
    rules: {
      type: Array,
      default () {return []}
    },
    errorMessages: {
      type: Array,
      default () {return []}
    },
    icon: {
      type: String,
      default: 'mdi-palette'
    },
    required: Boolean
  },

  data: function () {
    return {
      isActive: false,
      lazyValue: null,
      filteredValue: null
    }
  },

  watch: {
    value (val) {
      this.updateLazyValue(true)
    },
    isActive (val) {
      if (!val) return
      this.updateLazyValue()
    }
  },

  mounted () {
    this.updateLazyValue()
    this.isActive = !this.readonly && !this.disabled && !!this.display
  },

  methods: {
    updateLazyValue (force) {
      var value = this.value || this.defaultColor
      if (value && !value.startsWith('#')) {
        value = '#' + value
      }
      console.warn('Setting color value', this.value, this.defaultColor, value)
      if (this.noAlpha && value && value.length > 7) {
        this.lazyValue = value.substring(0, 7)
      } else {
        this.lazyValue = value
      }
      if (!this.filteredValue || force) {
        this.filteredValue = value
      }
    },
    closePicker () {
      this.isActive = false
    },
    set () {
      this.filteredValue = this.lazyValue
      this.$emit('input', this.lazyValue)
      this.closePicker()
    },
    resetToPrevious () {
      this.updateLazyValue(true)
    },
    resetToDefault () {
      setTimeout(() => this.$emit('input', this.defaultColor), 0)
    }
  }
}
</script>
<style>
.ft-color-picker.ft-has-title .v-color-picker {
  border-radius: 0% !important;
}
</style>
